import { render } from "./swPageRedirect.vue?vue&type=template&id=1f45fad4&scoped=true"
import script from "./swPageRedirect.vue?vue&type=script&lang=js"
export * from "./swPageRedirect.vue?vue&type=script&lang=js"

import "./swPageRedirect.vue?vue&type=style&index=0&id=1f45fad4&scoped=true&lang=scss"

import exportComponent from "/pxplus_redirect/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f45fad4"]])

export default __exports__